import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetUserBadgeResponseBody } from '../UserBadgesApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseUserBadgeQueryValues = {
  appId: string;
  userBadgeId: string;
};

export const userBadgeQueryKeyFactory: IQueryKeyFactory<
  IUseUserBadgeQueryValues
> = (values) =>
  values && (['userBadge', values.appId, values.userBadgeId] as const);

export const useUserBadgeQuery = (
  values?: IUseUserBadgeQueryValues,
  options?: UseQueryOptions<IApiGetUserBadgeResponseBody, ApiError>,
): UseQueryResult<IApiGetUserBadgeResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: userBadgeQueryKeyFactory(values),
    queryFn: values
      ? () => api.userBadges.get(values.appId, values.userBadgeId)
      : undefined,
    ...options,
  });
};
